<p-overlayPanel #picpreview>
    <ng-template pTemplate>
        <div class="image-preview">
            <img [src]="_productService.thImages[i].image" />
        </div>
    </ng-template>
</p-overlayPanel>

<div
  class="uploadbox"
  [ngClass]="{
    'is-empty': !_productService.thImages.length,
    'view-only': _productService.isViewOnly
  }"
>
  <div class="upload-body">
    <div
      class="upload-btn-div"
      *ngIf="!_productService.isViewOnly"
      [class.disabled]="!ok2AddThumbnails() || _productService.isViewOnly"
    >
      <label
        data-kt-image-input-action="change"
        data-bs-toggle="tooltip"
        title="Add/Change image"
        [class.disabled-label]="
          !ok2AddThumbnails() || _productService.isViewOnly
        "
      >
        <span class="upload-text">Click to upload images. Recommended size: 1:1 (500x500)</span>
        <span class="upload-format-hint">Supported formats: PNG, JPG, JPEG, WEBP, GIF, BMP, SVG, AVIF</span>
        <i class="pi pi-cloud-upload upload-icon"></i>
        <input
          type="file"
          name="avatar"
          accept=".png,.jpg,.jpeg,.webp,.gif,.bmp,.svg,.avif"
          multiple="true"
          (change)="handleFileInputMultiple($event)"
          [hidden]="true"
          [disabled]="
            !ok2AddThumbnails() || _productService.isViewOnly
          "
        />
        <input type="hidden" name="avatar_remove" />
      </label>
    </div>

    <div class="thumbs-container">
      <div class="thumbs">
        <div
          *ngFor="
            let image of _productService.thImages;
            let i = index
          "
          class="img-container"
        >
          <button
            *ngIf="!_productService.isViewOnly"
            type="button"
            class="thumb-remove"
            pTooltip="Remove Image"
            (click)="onRemoveClick($event, i)"
          >
            <i class="pi pi-times"></i>
          </button>
          <button
            *ngIf="!_productService.isViewOnly"
            type="button"
            class="thumb-feature-btn"
            pTooltip="Set as Feature Image"
            (click)="setFeatureImage(image, i)"
            [class.active]="_productService.featureImageIndex === i"
          >
            <i class="pi pi-star"></i>
            <span class="btn-text">Feature</span>
          </button>
          <p-image
            [src]="image"
            [preview]="true"
            appendTo="body"
            alt="Product image"
            class="thumb-img"
          ></p-image>
          <div
            class="feature-flag"
            *ngIf="_productService.featureImageIndex === i"
          >
            Feature
          </div>
          <div
            class="thumb-feature-tag"
            *ngIf="
              _productService.featureImageIndex === i &&
              _productService.isViewOnly
            "
          >
            <i class="pi pi-star"></i>
            <span>Feature</span>
          </div>
        </div>

        <div
          class="empty-state inline-empty"
          *ngIf="!_productService.thImages.length"
        >
          <span class="empty-title">No images yet</span>
          <span class="empty-sub"
            >Upload up to 10 images to showcase your product.</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div class="gallery-status">
    <div class="remaining" *ngIf="_productService.thImages.length">
        {{ remainingImages }}
        {{ remainingImages === 1 ? "image" : "images" }} remaining
    </div>
</div>


